/*
  Detect environment by uri (production/dev in azure are deployed from same build)
*/

export const environmentByUri = window.location.origin.includes('4200')
  ? 'local'
  : window.location.host.includes('dev')
    ? 'development'
    : 'production';

const config = {
  local: {
    msalClientId: '1e280472-9835-4f6e-b1dc-c6e148d0d21f',
    msalProtectedResourceUri: `api://1e280472-9835-4f6e-b1dc-c6e148d0d21f/Rantalainen.Flow`,
    msalRedirectUri: window.location.origin,

    // cannot use absolute path / https://stackoverflow.com/a/59586462/1593929
    apiUri: '//' + window.location.host + '/api',

    // For cross linking purposes
    otherEnvironmentUri: 'https://flow.rantalainen.fi',
  },

  development: {
    msalClientId: '1e280472-9835-4f6e-b1dc-c6e148d0d21f',
    msalProtectedResourceUri: `api://1e280472-9835-4f6e-b1dc-c6e148d0d21f/Rantalainen.Flow`,
    msalRedirectUri: 'https://flow-dev.rantalainen.fi',

    apiUri: '//flow-api-dev.rantalainen.fi/api',

    // For cross linking purposes
    otherEnvironmentUri: 'https://flow.rantalainen.fi',
  },

  production: {
    msalClientId: 'b1473550-61e1-41d3-ad5a-c6c948297453',
    msalProtectedResourceUri: 'api://b1473550-61e1-41d3-ad5a-c6c948297453/Rantalainen.Flow',
    msalRedirectUri: 'https://flow.rantalainen.fi',

    apiUri: '//flow-api.rantalainen.fi/api',

    // For cross linking purposes
    otherEnvironmentUri: 'https://flow-dev.rantalainen.fi',
  },
};

export const configByUri = config[environmentByUri];
